import { Component, Input } from '@angular/core';
import { ThemeService } from '../services/theme.service';

@Component({
  selector: 'app-form-section-header',
  templateUrl: './form-section-header.component.html',
  styleUrl: './form-section-header.component.scss'
})
export class FormSectionHeaderComponent {
  @Input() title?: string;
  @Input() icon?: string;

  constructor(public themeService: ThemeService) {}
}
